export const DEFAULT_DATAPOINT_RADIUS = 2;

// Design breakpoints in desc order
const RADIUS_BREAKPOINTS = [
  {
    breakpoint: 576,
    radius: 3,
  },
];

/**
 * Calculates the radius of the circle based on height and width.
 */
export const calculateArcRadius = (height: number, width: number) => {
  for (const { breakpoint, radius } of RADIUS_BREAKPOINTS) {
    if (height >= breakpoint && width >= breakpoint) {
      return radius;
    }
  }

  return DEFAULT_DATAPOINT_RADIUS;
};
